(() => {
  const STORAGE_KEY = "cart_countdown_expiry_v5";
  const DURATION_MS = 10 * 60 * 1000; // 10 minutes

  const COUNT_SEL = "[data-header-cart-count]";    // Cart count element in header
  const URGENCY_SEL = ".cart-urgency";             // Urgency banner
  const COUNTDOWN_SEL = ".cart-urgency .js-countdown"; // Countdown display

  const now = () => Date.now();

  function readExpiry() {
    try {
      const v = Number(sessionStorage.getItem(STORAGE_KEY));
      return Number.isFinite(v) ? v : null;
    } catch (_) {
      return null;
    }
  }

  function writeExpiry(ms) {
    try {
      sessionStorage.setItem(STORAGE_KEY, String(ms));
    } catch (_) {}
  }

  function clearExpiry() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  }

  function getCartCount() {
    const el = document.querySelector(COUNT_SEL);
    if (!el) return null;
    const n = Number(String(el.textContent || "").trim());
    return Number.isFinite(n) ? n : null;
  }

  function format(diffMs) {
    if (diffMs <= 0) return "0:00";
    const total = Math.floor(diffMs / 1000);
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${m}:${String(s).padStart(2, "0")}`;
  }

  function hideUrgencyEverywhere() {
    document.querySelectorAll(URGENCY_SEL).forEach((el) => {
      el.style.display = "none";
    });
  }

  function showUrgencyEverywhere() {
    document.querySelectorAll(URGENCY_SEL).forEach((el) => {
      el.style.display = "";
    });
  }

  function render() {
    const expiry = readExpiry();
    if (!expiry) return; // Timer not started yet

    const diff = expiry - now();

    if (diff <= 0) {
      hideUrgencyEverywhere();
      clearExpiry();
      return;
    }

    /* showUrgencyEverywhere();  */ /* den her skal bare slåes til for at den kommer frem */

    const txt = format(diff);
    document.querySelectorAll(COUNTDOWN_SEL).forEach((node) => {
      node.textContent = txt;
    });
  }

  let interval = null;
  function ensureTicking() {
    if (interval) return;
    interval = setInterval(render, 1000);
  }

  // Start timer ONLY when cart transitions from 0 to >0
  function maybeStartOnAdd(prevCount, nextCount) {
    if (readExpiry()) return; // Already started
    if (prevCount === 0 && nextCount > 0) {
      writeExpiry(now() + DURATION_MS);
      ensureTicking();
      render();
    }
  }

  // Clear timer if cart becomes empty
  function maybeClearOnEmpty(nextCount) {
    if (nextCount === 0) {
      clearExpiry();
      hideUrgencyEverywhere();
    }
  }

  function boot() {
    // Hide banner until timer starts
    if (!readExpiry()) {
      hideUrgencyEverywhere();
    }

    // If expiry already exists in session (user reloaded page), continue timer
    if (readExpiry()) {
      ensureTicking();
      render();
    }

    let lastCount = getCartCount();
    if (lastCount == null) lastCount = 0;

    // Watch cart count element for changes
    const countEl = document.querySelector(COUNT_SEL);
    if (!countEl) {
      console.warn('Cart urgency: Could not find cart count element');
      return;
    }

    const mo = new MutationObserver(() => {
      const next = getCartCount();
      if (next == null) return;

      maybeStartOnAdd(lastCount, next);
      maybeClearOnEmpty(next);

      lastCount = next;
    });

    mo.observe(countEl, {
      childList: true,
      characterData: true,
      subtree: true
    });

    // Listen for cart update events from the cart form
    document.addEventListener('cart:updated', () => {
      const next = getCartCount();
      if (next != null) {
        maybeStartOnAdd(lastCount, next);
        maybeClearOnEmpty(next);
        lastCount = next;
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
